<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardTicketList.push"
    :query-list="queryList"
    :is-show-select-card-payment-mode-id="true"
    :is-card-payment-mode-multiple="true"
    :is-show-quick-time-tab="true"
    :is-show-expire-numbers="true"
    :is-show-student-select="true"
    :is-show-store-select="true"
    :is-multiple-store="true"
    :has-private-store="true"
    store-select-label="归属门店"
    card-payment-mode-label="收款方式"
    student-select-label="所属学员"
    quick-time-tab-label="添加日期"
    :is-show-quick-time-tab-last-thirty-day="true"
    :picker-options="pickerOptionsBetweenSystemStartAndToday"
    :show-summary="true"
  >

    <template slot="header-item">
      <v-tab-quick-time
        :is-hide-quick-time="true"
        label="失效日期"
        v-model="timeLimitExpire"
        :picker-options="pickerOptionsOfAfterSystemStartDay"
        @input="handleTimeLimitExpireChange"
        size="small"
      />

      <v-select-card-ticket-state
        label="课次券状态"
        v-model="queryList.card_ticket_states"
        :multiple="true"
        size="small"
        @input="handleStateChange"
      />

      <div class="flex-align-center flex-wrap table-filter-item">
        <div class="flex-align-center table-filter-label">课次券类型：</div>
        <v-select-card-ticket-type
          v-model="queryList.card_ticket_type_ids"
          :multiple="true"
          :is-filter="true"
          size="small"
          placeholder="输入名称搜索"
          @change="handleTypeChange"
        />
      </div>
    </template>

    <v-column-time/>
    <v-column-time value="失效时间" field="expire_time" time-format="timeToYmdHi" empty-tip="-" sortable=""/>
    <v-column-time value="生效时间" field="effect_time" time-format="timeToYmdHi" empty-tip="-" sortable=""/>

    <el-table-column label="归属门店">
      <template v-slot="{ row }">
        <el-tag size="mini" :type="row.is_app ? 'warning' : 'info'">{{ row.source_name }}</el-tag>
        <span :class="{ 'info-color': !row.store_id }" style="margin-left: 4px;">{{ row.store_name }}</span>
        <div v-if="row.is_app && row.store_id" class="info-color">
          {{ row.store_source_name }}
        </div>
        <div v-else-if="row.is_app" class="info-color">签到/爽约后自动归属</div>
        <div v-else class="info-color">{{ row.store_source_name || '后台办理自动归属' }}</div>
      </template>
    </el-table-column>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="课次券类型" prop="card_ticket_type_name"/>

    <el-table-column label="有效天数">
      <template v-slot="{ row }">
        {{ row.expire_days | toYuan }}
      </template>
    </el-table-column>

    <el-table-column label="剩余次数">
      <template v-slot="{ row }">
        {{ row.expire_number | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="实际收款(元)" prop="actual_payment" type="money">
      <template v-slot="{ row }">
        <span>{{ row.actual_payment | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="收款方式">
      <template v-slot="{ row }">
        <span v-if="row.card_id" class="info-color">办卡赠送</span>
        <span v-else>{{ findPaymentModeName(row.card_payment_mode_id) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="未消费(元)" prop="not_consumed_amount" type="money">
      <template v-slot="{ row }">
        <span>{{ row.not_consumed_amount | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="状态" width="62px">
      <template v-slot="{ row }">
        <span v-if="row.we_chat_order_id && !row.is_paid" class="warning-color">待支付</span>
        <span v-else-if="!row.expire_number" class="info-color">已用完</span>
        <span v-else-if="!row.expire_time" class="primary-color">未开券</span>
        <span v-else-if="row.is_expired" class="info-color">已过期</span>
        <span v-else-if="!row.effect_time" class="warning-color">待生效</span>
        <span v-else class="success-color">可使用</span>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="310">
      <template v-slot="{ row }">
        <template v-if="!row.we_chat_order_id || (row.we_chat_order_id && row.is_paid)">
          <template v-if="isAdministrator">
            <v-list-button icon="update-date" name="修改日期" size="large" :to="RouteConfig.cardTicketEditDate.to(row.id)"/>
            <v-list-button icon="update-number" name="修改次数" size="large"  :to="RouteConfig.cardTicketEditNumber.to(row.id)"/>
            <v-popover name="退券" :to="RouteConfig.cardTicketDelete.to(row.id)">
              <v-popover-item icon="view" name="查看课券" :to="RouteConfig.cardTicketDetail.to(row.id)"/>
            </v-popover>
          </template>
          <v-list-button v-else icon="view" name="查看" size="large" :to="RouteConfig.cardTicketDetail.to(row.id)"/>
        </template>

      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>失效时间</span>
              <span>{{ v.expire_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>生效时间</span>
              <span>{{ v.effect_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>归属门店</span>
              <span>
                <el-tag size="mini" :type="v.is_app ? 'warning' : 'info'">{{ v.source_name }}</el-tag>
                <span :class="{ 'info-color': !v.store_id }">{{ v.store_name }}</span>
              </span>
            </div>

            <div class="list-item-detail">
              <span>归属依据</span>
              <span>{{ v.store_id ? v.store_source_name : (v.is_app ? '签到/爽约后自动归属' : '后台办理自动归属') }}</span>
            </div>

            <div class="list-item-detail">
              <span>课次券类型</span>
              <span>{{ v.card_ticket_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>有效天数（天）</span>
              <span>{{ v.expire_days | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>剩余次数（次）</span>
              <span>{{ v.expire_number | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>实际收款（元）</span>
              <span>{{ v.actual_payment | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>收款方式</span>
              <span v-if="v.card_id" class="info-color">办卡赠送</span>
              <span v-else>{{ findPaymentModeName(v.card_payment_mode_id) }}</span>
            </div>

            <div class="list-item-detail">
              <span>未消费（元）</span>
              <span>{{ v.not_consumed_amount | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>状态</span>
              <span v-if="v.we_chat_order_id && !v.is_paid" class="warning-color">待支付</span>
              <span v-else-if="!v.expire_number" class="info-color">已用完</span>
              <span v-else-if="!v.expire_time" class="primary-color">未开券</span>
              <span v-else-if="v.is_expired" class="info-color">已过期</span>
              <span v-else-if="!v.effect_time" class="warning-color">待生效</span>
              <span v-else class="success-color">可使用</span>
            </div>

            <div class="list-item-button">
              <template v-if="!v.we_chat_order_id || (v.we_chat_order_id && v.is_paid)">
                <template v-if="isAdministrator">
                  <v-list-button icon="update-date" name="修改日期" size="large" :to="RouteConfig.cardTicketEditDate.to(v.id)"/>
                  <v-list-button icon="update-number" name="修改次数" size="large"  :to="RouteConfig.cardTicketEditNumber.to(v.id)"/>
                  <v-popover name="退券" :to="RouteConfig.cardTicketDelete.to(v.id)">
                    <v-popover-item icon="view" name="查看课券" :to="RouteConfig.cardTicketDetail.to(v.id)"/>
                  </v-popover>
                </template>
                <v-list-button v-else icon="view" name="查看" size="large" :to="RouteConfig.cardTicketDetail.to(v.id)"/>
              </template>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>实际收款</span>
              <span class="income-count">{{ actual_payment | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>未消费</span>
              <span>{{ not_consumed_amount | toYuan }} 元</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index } from '@/api/card-ticket';
import { getLegalQueryList, pickerOptionsOfAfterSystemStartDay, pickerOptionsBetweenSystemStartAndToday } from '@/utils/formats';
import { checkYmdIsBetweenSetUpAndToday } from "@/utils/validate";
import { toCent } from "@/utils/number";
import { findPaymentModeName } from "@/enums/paymentModes";
import { plus } from "@/filters";

export default {
  name: RouteConfig.cardTicketList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    actual_payment: 0,
    not_consumed_amount: 0,
    list: [],
    queryList: {
      keyword: '',
      card_state: 0,
      card_ticket_type_ids: [],
      card_payment_mode_id: 0,
      start_date: '',
      end_date: '',
      start_date_expire: '',
      end_date_expire: '',
      card_ticket_states: [],
      is_asc: 0,
      page: 1,
      size: 10,
    },
    pickerOptionsOfAfterSystemStartDay,
    pickerOptionsBetweenSystemStartAndToday,
    isLoading: false,
    timeLimit: [],
    timeLimitExpire: [],
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
    queryList(queryList) {
      this.timeLimit = [queryList.start_date, queryList.end_date];
      this.timeLimitExpire = [queryList.start_date_expire, queryList.end_date_expire];
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isMobile',
    ]),
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findPaymentModeName,
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        queryList.start_date = '';
        queryList.end_date = '';
      }

      const params = { ...queryList };

      params.expire_number_min = toCent(params.expire_number_min);
      params.expire_number_max = toCent(params.expire_number_max);

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      let actual_payment = 0;
      let not_consumed_amount = 0;

      this.count = data.count;
      this.list = data.list;

      data.list.forEach(item => {
        actual_payment = plus(actual_payment, item.actual_payment);
        not_consumed_amount = plus(not_consumed_amount, item.not_consumed_amount);
      });

      this.actual_payment = actual_payment;
      this.not_consumed_amount = not_consumed_amount;
      if (next) next();
    },

    refresh() {
      RouteConfig.cardTicketList.push(this.queryList);
    },

    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },

    handleTimeLimitExpireChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date_expire, end_date_expire] = times;

      Object.assign(this.queryList, {
        start_date_expire,
        end_date_expire,
        page: 1,
      });
      this.refresh();
    },

    handleStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },

    handleTypeChange(value) {
      this.queryList.card_ticket_type_ids = value || [];
      this.queryList.page = 1;
      this.refresh();
    },

  },
};
</script>
